var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.691,
    height: 15.067,
    viewBox: "0 0 13.691 15.067",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "user",
    d: "M11.379,8.334a4.107,4.107,0,1,0-5.06,0A6.851,6.851,0,0,0,2,14.688v.685a.685.685,0,0,0,.685.685H15.007a.685.685,0,0,0,.685-.685v-.685a6.851,6.851,0,0,0-4.313-6.355ZM6.107,5.1A2.738,2.738,0,1,1,8.846,7.843,2.738,2.738,0,0,1,6.107,5.1ZM3.369,14.688a5.477,5.477,0,1,1,10.953,0Z",
    transform: "translate(-2 -0.991)",
    fill: "#3b57a9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.4b638a2b4db4ef91e19b72b30a8d5ef3.svg";
export { ForwardRef as ReactComponent };